export const shadows = {
  box: '-1px 1px 4px 0px #0000001A inset, 4px -4px 4px 0px #00000040',
  active: '0px 0px 20px 0px #5FBACB26',
  inset: '0px 8px 4px 3px #FFFFFF40 inset, 0px -4px 4px 0px #00000040 inset',
  number:
    '0px -3px 0px 0px #D6D6E7 inset, 0px 4px 8px -3px #2D23424D, 0px 2px 4px 0px #2C234266',
  category:
    '0px -3px 0px 0px #D6D6E7 inset, 0px 4px 8px -3px #2D23424D, 0px 2px 4px 0px #2C234266',
  layoutCard: '0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.04)',
};

export default shadows;
